const licensePlateMask = [
  /[A-Za-z]/,
  /[A-Za-z]/,
  /[A-Za-z]/,
  /[0-9]/,
  /[0-9A-Za-z]/,
  /[0-9]/,
  /[0-9]/,
];

export default licensePlateMask;
